import { type Shipment } from '~shared/types';

// Kept for callers that still reference the shipments API version (e.g. web OrderDetails).
export const SHIPMENTS_API_VERSION = 'v3';

// Networking for shipments now lives in React Query (useGetShipments in queries/useShipments.ts;
// query keys in queries/query-keys/shipments.ts). This setter only mirrors the fetched data into
// the Redux slice so existing Reselect selectors (getShipments → checkout's getOrder, etc.) keep
// working — the transitional bridge step toward strategy A. See the
// redux-thunk-to-react-query-migration skill.
export const SET_SHIPMENTS = 'SET_SHIPMENTS';

export type SetShipments = {
  type: typeof SET_SHIPMENTS;
  payload: Shipment[];
};

export function setShipments(shipments: Shipment[]): SetShipments {
  return {
    type: SET_SHIPMENTS,
    payload: shipments,
  };
}
